// tslint:disable:no-any

import * as React from 'react';
import ReactHighcharts from 'react-highcharts';
import {
    DisplayTemp,
    DisplayDepth,
    DisplayMixPressure
} from '../components/Display';

const ReactHighstock = require('react-highcharts/ReactHighstock');

ReactHighstock.Highcharts.Pointer.prototype.reset = function() {
    return undefined;
};

ReactHighstock.Highcharts.Point.prototype.highlight = function(event: Event) {
    this.onMouseOver();
    this.series.chart.xAxis[0].drawCrosshair(event, this);
};

function hcContainerBind(charts: any, sourceChart: any, e: any) {
    let chart, point, i, event;

    for (i = 0; i < charts.length; i = i + 1) {
        chart = charts[i];
        if (chart && chart.pointer && e) {
            event = chart.pointer.normalize(e);
            point = chart.series[0].searchPoint(event, true);

            if (
                e.target &&
                e.target.className &&
                e.target.className.baseVal &&
                e.target.className.baseVal === 'highcharts-label-box' &&
                chart === sourceChart
            ) {
                point = undefined;
            }

            if (point) {
                point.highlight(e);
            }
        }
    }
}

function getTooltipContent(
    points: any,
    point: any,
    chart: any,
    chartData: any
) {
    // zjistim pozici kurzoru
    let x: any = null;
    // ze seznamu pozic
    if (points) {
        points.forEach((p: any) => {
            if (x === null) {
                x = p.x;
            }
        });
    }
    // z jedne pozice
    if (!points && point) {
        x = point.x;
    }

    // hledam konkretni event na adrese
    let event: any = null;
    if (x && chartData.events && chartData.events.data) {
        chartData.events.data.forEach((d: any) => {
            if (event === null && d.x > x - 5 && d.x < x + 5) {
                event = d;
            }
        });
    }

    let ret = '';

    // data grafu
    ret +=
        '<ul style="margin:0;margin-right:30px;padding:0;list-style-type:none;">';
    chartData.series.forEach((s: any) => {
        let found = false;
        ret +=
            '<li style="padding-left:0;margin-left:0;">' +
            '<span style="float:left;margin-top:-3px;margin-right:2px;font-size:20pt;color:' +
            ReactHighcharts.Highcharts.getOptions().colors[s.index] +
            ';">&bullet;</span>' +
            '<span>' +
            '<b>' +
            s.name +
            '</b>: ';
        if (points) {
            points.forEach((p: any) => {
                if (
                    p.series &&
                    p.series.userOptions &&
                    p.series.userOptions.id === s.id
                ) {
                    ret += chartData.valueFormat(p.y);
                    found = true;
                }
            });
        }
        if (!points) {
            if (s.data[x]) {
                ret += chartData.valueFormat(s.data[x]);
                found = true;
            }
        }
        // serie na dane pozici nema data
        if (found === false) {
            ret += '–';
        }
        ret += '</span>' + '</li>';
    });
    ret += '</ul>';

    // event
    if (event) {
        ret +=
            '<div style="margin-top:5px;line-height:16px;">' +
            '<b>Diver Error:</b><br>' +
            event.text +
            '</div>';
    }

    return ret;
}

export default class DiveCharts extends React.PureComponent<any> {
    generateChartsData(diveData: any, diveEvents: any) {
        if (
            diveData === [] ||
            diveData.depth === undefined ||
            diveEvents === undefined
        ) {
            return [];
        }

        const getTimeLabel = (value: number) => {
            let m = Math.floor(value / 60);
            let s = value - m * 60;
            let mString = '' + m;
            let sString = '' + s;

            if (m < 10) {
                mString = '0' + m;
            }
            if (s < 10) {
                sString = '0' + s;
            }

            return mString + ':' + sString;
        };

        let chartsData = [];

        let min = 0;
        let max = 0;

        let lastValue: any = null;
        let labelText = '';
        let labelColor = '';
        let modeColor = '';
        let categories = [];
        let depthData: any = [];
        let ceilingData: any = [];
        let ppo2Data: any = [];
        let setpointData: any = [];
        let temperatureData: any = [];
        let eventsData: any = [];
        let firstTemperatureData: any = null;

        diveData.depth.forEach((k: any) => {
            if (k.timestamp > max) {
                max = k.timestamp;
            }
            depthData[k.timestamp] = DisplayDepth.getValue(k.value);
        });
        diveData.ceiling.forEach((k: any) => {
            ceilingData[k.timestamp] = DisplayDepth.getValue(k.ceiling);
        });
        diveData.ppo2.forEach((v: any) => {
            // ppo2Data[v.timestamp] = DisplayMixPressure.getValue(
            //     v.pressureInBar
            // );
            ppo2Data[v.timestamp] = v.pressureInBar;
        });
        diveData.setpoint.forEach((v: any) => {
            // setpointData[v.timestamp] = DisplayMixPressure.getValue(
            //     v.pressureInBar
            // );
            setpointData[v.timestamp] = v.pressureInBar;
        });
        diveData.temperature.forEach((k: any) => {
            if (firstTemperatureData === null) {
                firstTemperatureData = DisplayTemp.getValue(k.temperature);
            }
            temperatureData[k.timestamp] = DisplayTemp.getValue(k.temperature);
        });

        diveEvents.forEach((k: any) => {
            eventsData[k.timestamp] = k;
        });

        // doplneni prazdnych elementu
        let flagsData = [];
        for (let i = min; i <= max; i++) {
            // hloubka
            if (depthData[i] === undefined) {
                depthData[i] = null;
            }
            // eventy
            if (eventsData[i]) {
                if (
                    eventsData[i].type &&
                    eventsData[i].type === 'Diver Error'
                ) {
                    flagsData.push({
                        x: eventsData[i].timestamp,
                        title: ' ',
                        text: eventsData[i].subType
                    });
                }
            }
            // dalsi hodnoty
            if (ceilingData[i] === undefined) {
                ceilingData[i] = null;
            }
            if (ppo2Data[i] === undefined) {
                ppo2Data[i] = null;
            }
            if (setpointData[i] === undefined) {
                setpointData[i] = null;
            }
            if (temperatureData[i] === undefined) {
                temperatureData[i] = null;
            }
            // popisek
            categories[i] = getTimeLabel(i);
        }

        let chartsDataDepth: any = {};
        chartsDataDepth.height = 300;
        chartsDataDepth.name = 'Depth, Ceiling';
        chartsDataDepth.unit = DisplayDepth.getUnit();
        chartsDataDepth.type = 'spline';
        chartsDataDepth.valueDecimals = 2;
        chartsDataDepth.valueFormat = DisplayDepth.display;
        chartsDataDepth.disableXAxis = false;
        chartsDataDepth.series = [];
        chartsDataDepth.series.push(
            {
                name: 'Depth',
                id: 'depth',
                index: 0,
                data: depthData,
                unit: DisplayDepth.getUnit(),
                reverseY: true
            },
            {
                name: 'Ceiling',
                id: 'ceiling',
                index: 1,
                data: ceilingData,
                unit: DisplayDepth.getUnit(),
                reverseY: true
            }
        );
        chartsDataDepth.events = null;
        if (flagsData.length > 0) {
            chartsDataDepth.events = {
                name: 'Diver Error',
                type: 'flags',
                data: flagsData,
                width: -1000,
                y: -7,
                onSeries: 'depth',
                shape: 'url(' + require('../assets/img/sign_warning.png') + ')',
                showInLegend: false,
                cursor: 'pointer',
                zIndex: 10000
            };
        }
        chartsDataDepth.legend = true;
        chartsDataDepth.spacingTop = 0;
        chartsDataDepth.spacingBottom = 0;
        chartsDataDepth.marginTop = 45;
        chartsDataDepth.marginRight = 30;
        chartsDataDepth.tooltipEnabled = true;
        chartsDataDepth.tooltipPositionY = -10;
        chartsDataDepth.lineWidth = null;
        chartsDataDepth.minorGridLineWidth = null;
        chartsDataDepth.gridLineColor = null;
        chartsDataDepth.plotBands = [];
        chartsDataDepth.categories = categories;
        chartsDataDepth.getTimeLabel = getTimeLabel;
        chartsDataDepth.zoomType = null;
        chartsData.push(chartsDataDepth);

        // ppO2, Setpoint
        let chartsDataSetpoint: any = {};
        chartsDataSetpoint.height = 300;
        chartsDataSetpoint.name = 'ppO2, Setpoint';
        chartsDataSetpoint.unit = DisplayMixPressure.getUnit('bar');
        chartsDataSetpoint.type = 'spline';
        chartsDataSetpoint.valueDecimals = 2;
        chartsDataSetpoint.valueFormat = DisplayMixPressure.display('bar');
        chartsDataSetpoint.disableXAxis = false;
        chartsDataSetpoint.series = [];
        chartsDataSetpoint.series.push(
            {
                name: 'ppO2',
                id: 'ppo',
                index: 2,
                data: ppo2Data,
                unit: DisplayMixPressure.getUnit('bar')
            },
            {
                name: 'Setpoint',
                id: 'setpoint',
                index: 3,
                data: setpointData,
                unit: DisplayMixPressure.getUnit('bar'),
                disableYAxis: true
            }
        );

        chartsDataSetpoint.legend = true;
        chartsDataSetpoint.spacingTop = 0;
        chartsDataSetpoint.spacingBottom = 0;
        chartsDataSetpoint.marginTop = 45;
        chartsDataSetpoint.marginRight = 30;
        chartsDataSetpoint.tooltipEnabled = true;
        chartsDataSetpoint.tooltipPositionY = -10;
        chartsDataSetpoint.lineWidth = null;
        chartsDataSetpoint.minorGridLineWidth = null;
        chartsDataSetpoint.gridLineColor = null;
        chartsDataSetpoint.plotBands = [];
        chartsDataSetpoint.categories = categories;
        chartsDataSetpoint.getTimeLabel = getTimeLabel;
        chartsDataSetpoint.zoomType = null;
        chartsData.push(chartsDataSetpoint);

        // temperature
        let chartsDataTemperature: any = {};
        chartsDataTemperature.height = 300;
        chartsDataTemperature.name = 'Temperature';
        chartsDataTemperature.unit = DisplayTemp.getUnit();
        chartsDataTemperature.type = 'spline';
        chartsDataTemperature.valueDecimals = 2;
        chartsDataTemperature.valueFormat = DisplayTemp.display;
        chartsDataTemperature.disableXAxis = false;
        chartsDataTemperature.series = [];
        chartsDataTemperature.series.push({
            name: 'Temperature',
            id: 'temperature',
            index: 4,
            data: temperatureData,
            unit: DisplayTemp.getUnit()
        });
        chartsDataTemperature.legend = true;
        chartsDataTemperature.spacingTop = 0;
        chartsDataTemperature.spacingBottom = 0;
        chartsDataTemperature.marginTop = 45;
        chartsDataTemperature.marginRight = 30;
        chartsDataTemperature.tooltipEnabled = true;
        chartsDataTemperature.tooltipPositionY = -8;
        chartsDataTemperature.lineWidth = null;
        chartsDataTemperature.minorGridLineWidth = null;
        chartsDataTemperature.gridLineColor = null;
        chartsDataTemperature.plotBands = [];
        chartsDataTemperature.categories = categories;
        chartsDataTemperature.getTimeLabel = getTimeLabel;
        chartsDataTemperature.zoomType = null;
        chartsData.push(chartsDataTemperature);

        // konstanty pro mody
        const ModeOC = 1;
        const ModeCCR = 2;
        const ModeMCCR = 3;
        const ModeFree = 4;
        const ModeGauge = 5;
        const ModeASCR = 6;
        const ModePSCR = 7;
        const ModeBOCCR = 8;

        // modes
        let modesData: any = [];
        let modesPlotBands = [];
        diveData.modes.forEach((k: any) => {
            switch (k.mode.toLowerCase()) {
                case 'oc':
                    modesData[k.timestamp] = ModeOC;
                    break;
                case 'ccr':
                    modesData[k.timestamp] = ModeCCR;
                    break;
                case 'mccr':
                    modesData[k.timestamp] = ModeMCCR;
                    break;
                case 'free':
                    modesData[k.timestamp] = ModeFree;
                    break;
                case 'gauge':
                    modesData[k.timestamp] = ModeGauge;
                    break;
                case 'ascr':
                    modesData[k.timestamp] = ModeASCR;
                    break;
                case 'pscr':
                    modesData[k.timestamp] = ModePSCR;
                    break;
                case 'boccr':
                    modesData[k.timestamp] = ModeBOCCR;
                    break;
                default:
                    modesData[k.timestamp] = 0;
            }
        });

        lastValue = null;
        let modesPlotBand: any = null;
        for (let i = min; i < max; i++) {
            if (modesData[i] === undefined && lastValue !== null) {
                modesData[i] = lastValue;
            } else if (modesData[i] !== undefined) {
                lastValue = modesData[i];
            } else {
                lastValue = 0;
            }
            if (modesPlotBand !== null && modesData[i] !== modesPlotBand.mode) {
                modesPlotBands.push(modesPlotBand);
                modesPlotBand = null;
            }
            if (modesPlotBand === null) {
                labelText = '';
                labelColor = '#FFFFFF';
                modeColor = '';
                switch (modesData[i]) {
                    case ModeOC:
                        labelText = 'OC';
                        modeColor = '#6495ED';
                        break;
                    case ModeCCR:
                        labelText = 'CCR';
                        modeColor = '#008000';
                        break;
                    case ModeMCCR:
                        labelText = 'MCCR';
                        modeColor = '#008000';
                        break;
                    case ModeFree:
                        labelText = 'FREE';
                        modeColor = '#FFFFFF';
                        break;
                    case ModeGauge:
                        labelText = 'GAUGE';
                        modeColor = '#FF0000';
                        break;
                    case ModeASCR:
                        labelText = 'ASCR';
                        modeColor = '#FFFFFF';
                        break;
                    case ModePSCR:
                        labelText = 'PSCR';
                        modeColor = '#FFFFFF';
                        break;
                    case ModeBOCCR:
                        labelText = 'BOCCR';
                        modeColor = '#FFFFFF';
                        break;
                    default:
                        labelText = '';
                        labelColor = '#333333';
                        break;
                }
                modesPlotBand = {};
                modesPlotBand.from = i;
                modesPlotBand.color = modeColor;
                modesPlotBand.mode = modesData[i];
                modesPlotBand.label = {
                    text: labelText,
                    style: { color: labelColor },
                    y: 33,
                    rotation: -35
                };
            }
            modesPlotBand.to = i;
        }
        if (modesPlotBand !== null) {
            modesPlotBands.push(modesPlotBand);
        }

        modesData.forEach((d: any, i: any) => {
            modesData[i] = 1;
        });

        let chartsDataModes: any = {};
        chartsDataModes.height = 90;
        chartsDataModes.name = 'Modes';
        chartsDataModes.unit = 'm';
        chartsDataModes.type = 'spline';
        chartsDataModes.valueDecimals = 0;
        chartsDataModes.disableXAxis = true;
        chartsDataModes.series = [];
        chartsDataModes.series.push({
            name: 'Modes',
            id: 'modes',
            data: modesData,
            unit: 'm',
            reverseY: false,
            disableYAxis: true
        });
        chartsDataModes.legend = false;
        chartsDataModes.spacingTop = 0;
        chartsDataModes.spacingBottom = 0;
        chartsDataModes.marginTop = 30;
        chartsDataModes.marginRight = 30;
        chartsDataModes.tooltipEnabled = false;
        chartsDataModes.lineWidth = 0;
        chartsDataModes.minorGridLineWidth = 0;
        chartsDataModes.gridLineColor = 'transparent';
        chartsDataModes.getTimeLabel = getTimeLabel;
        chartsDataModes.plotBands = modesPlotBands;
        chartsDataModes.categories = [];
        chartsData.push(chartsDataModes);

        // mixes
        let mixesData: any = [];
        let mixesPlotBands = [];

        lastValue = null;
        diveData.mixes.forEach((k: any) => {
            if (lastValue === null) {
                lastValue = {
                    mixType: k.mixType,
                    mixHe: k.mixHe,
                    mixO2: k.mixO2
                };
            }
            mixesData[k.timestamp] = {
                mixType: k.mixType,
                mixHe: k.mixHe,
                mixO2: k.mixO2
            };
        });

        let mixesPlotBand: any = null;
        for (let i = min; i < max; i++) {
            if (!mixesData[i] && !lastValue) {
                continue;
            }

            if (mixesData[i] === undefined && lastValue !== null) {
                mixesData[i] = lastValue;
            } else if (mixesData[i] !== undefined) {
                lastValue = mixesData[i];
            } else {
                lastValue = 0;
            }
            if (
                mixesPlotBand != null &&
                (mixesData[i].mixType !== mixesPlotBand.mode ||
                    mixesData[i].mixHe !== mixesPlotBand.mixHe ||
                    mixesData[i].mixO2 !== mixesPlotBand.mixO2)
            ) {
                mixesPlotBands.push(mixesPlotBand);
                mixesPlotBand = null;
            }
            if (mixesPlotBand === null) {
                labelText = '';
                labelColor = '#FFFFFF';
                modeColor = '';
                if (mixesData[i] !== undefined) {
                    switch (mixesData[i].mixType) {
                        case 'air':
                        case 'oxygen':
                            labelText = mixesData[i].mixType
                                .substring(0, 3)
                                .toUpperCase();
                            labelColor = '#FFFFFF';
                            modeColor = '#5F6EFF';
                            break;
                        case 'ean':
                            labelText = `EAN ${mixesData[i].mixO2}`;
                            labelColor = '#333333';
                            modeColor = '#89C331';
                            break;
                        case 'trimix':
                            labelText = `TMX ${mixesData[i].mixO2}/${mixesData[i].mixHe}`;
                            modeColor = '#A60F08';
                            break;
                        default:
                            labelText = '';
                    }
                } else {
                    labelText = '';
                    modeColor = '#FFFFFF';
                }

                mixesPlotBand = {};
                mixesPlotBand.from = i;
                mixesPlotBand.color = modeColor;
                mixesPlotBand.mode =
                    mixesData[i] !== undefined ? mixesData[i].mixType : 0;
                mixesPlotBand.label = {
                    text: labelText,
                    style: { color: labelColor },
                    y: 33,
                    rotation: -35
                };
                mixesPlotBand.mixType = mixesData[i].mixType;
                mixesPlotBand.mixHe = mixesData[i].mixHe;
                mixesPlotBand.mixO2 = mixesData[i].mixO2;
            }
            mixesPlotBand.to = i;
        }
        if (mixesPlotBand != null) {
            mixesPlotBands.push(mixesPlotBand);
        }

        mixesData.forEach((d: any, i: any) => {
            mixesData[i] = 1;
        });

        let chartsDataMixes: any = {};
        chartsDataMixes.height = 110;
        chartsDataMixes.name = 'Mixes';
        chartsDataMixes.unit = 'm';
        chartsDataMixes.type = 'line';
        chartsDataMixes.valueDecimals = 0;
        chartsDataMixes.disableXAxis = true;
        chartsDataMixes.series = [];
        chartsDataMixes.series.push({
            name: 'Mixes',
            id: 'mixes',
            data: mixesData,
            unit: 'm',
            reverseY: false,
            disableYAxis: true
        });
        chartsDataMixes.legend = false;
        chartsDataMixes.spacingTop = 0;
        chartsDataMixes.spacingBottom = 20;
        chartsDataMixes.marginTop = 30;
        chartsDataMixes.marginRight = 30;
        chartsDataMixes.tooltipEnabled = false;
        chartsDataMixes.lineWidth = 0;
        chartsDataMixes.minorGridLineWidth = 0;
        chartsDataMixes.gridLineColor = 'transparent';
        chartsDataMixes.getTimeLabel = getTimeLabel;
        chartsDataMixes.plotBands = mixesPlotBands;
        chartsDataMixes.categories = [];
        chartsData.push(chartsDataMixes);

        return chartsData;
    }

    render() {
        const { diveData, diveEvents } = this.props;

        let charts: any = [];

        const afterRender = (chart: any) => {
            const hcContainers = document.getElementsByClassName(
                'hc-container'
            );
            const bindedFunc = hcContainerBind.bind(
                null,
                ReactHighstock.Highcharts.charts,
                chart
            );
            [].forEach.call(hcContainers, (el: any) => {
                el.onmousemove = el.ontouchmove = el.ontouchstart = bindedFunc;
            });
        };

        if (
            diveData.depth === undefined ||
            diveData.depth === null ||
            diveData.depth.length === 0 ||
            diveEvents === undefined
        ) {
            return <div />;
        }
        let chartsData = this.generateChartsData(diveData, diveEvents);

        let colorIndex = 0;
        chartsData.map((chartData, i) => {
            let configSeries: any = [];
            let configYAxis: any = [];
            chartData.series.forEach((serie: any, si: any) => {
                // y souradnice
                configYAxis.push({
                    reversed: serie.reverseY,
                    title: {
                        text: null
                    },
                    labels: {
                        enabled: serie.disableYAxis !== true,
                        format: '{value} ' + serie.unit,
                        style: {
                            color: ReactHighcharts.Highcharts.getOptions()
                                .colors[colorIndex]
                        }
                    },
                    min: 0,
                    opposite: serie.yAxisOpposite,
                    gridLineColor:
                        chartData.gridLineColor !== null
                            ? chartData.gridLineColor
                            : '#e6e6e6',
                    minorGridLineColor:
                        chartData.gridLineColor !== null
                            ? chartData.gridLineColor
                            : '#e6e6e6',
                    minorGridLineWidth:
                        chartData.minorGridLineWidth !== null
                            ? chartData.minorGridLineWidth
                            : 1
                });
                // serial
                configSeries.push({
                    data: serie.data,
                    name: serie.name,
                    id: serie.id,
                    type: chartData.type,
                    yAxis: 0,
                    color: ReactHighcharts.Highcharts.getOptions().colors[
                        colorIndex
                    ],
                    fillOpacity: 0.3,
                    connectNulls: true,
                    lineWidth:
                        chartData.lineWidth !== null ? chartData.lineWidth : 3,
                    tooltip: {
                        valueSuffix: ' ' + serie.unit
                    },
                    states: {
                        hover: {
                            enabled: false
                        }
                    }
                });

                colorIndex++;

                return chartData;
            });

            if (chartData.events !== undefined && chartData.events !== null) {
                configSeries.push(chartData.events);
            }

            let chart = (
                <div className="hc-container" key={chartData.name}>
                    <ReactHighstock
                        // tslint:disable-next-line:jsx-no-string-ref
                        ref="charts"
                        isPureConfig
                        pure
                        config={{
                            chart: {
                                marginLeft: 70,
                                marginTop: chartData.marginTop,
                                marginRight: chartData.marginRight,
                                spacingTop: chartData.spacingTop,
                                spacingBottom: chartData.spacingBottom,
                                height: chartData.height,
                                zoomType: chartData.zoomType
                            },
                            // to highstocks
                            navigator: {
                                enabled: false
                            },
                            rangeSelector: {
                                enabled: false,
                                selected: 0
                            },
                            //
                            title: {
                                text: chartData.name,
                                align: 'left',
                                margin: 0,
                                x: 20
                            },
                            credits: {
                                enabled: false
                            },
                            legend: {
                                enabled: chartData.legend
                            },
                            xAxis: {
                                crosshair: {
                                    color: '#333333',
                                    width: 1,
                                    zIndex: 100
                                },
                                labels: {
                                    enabled: chartData.disableXAxis === false,
                                    formatter: function() {
                                        return chartData.getTimeLabel(
                                            (this as any).value
                                        );
                                    }
                                },
                                scrollbar: {
                                    enabled: false
                                },
                                plotBands: chartData.plotBands,
                                tickColor: chartData.disableXAxis
                                    ? 'transparent'
                                    : '#ccd6eb',
                                tickLength: chartData.disableXAxis ? 0 : 5
                            },
                            yAxis: configYAxis,
                            scrollbar: {
                                enabled: false
                            },
                            tooltip: {
                                shared: true,
                                enabled: chartData.tooltipEnabled,
                                useHTML: true,
                                formatter: function() {
                                    return (
                                        '<div style="min-width:130px;line-height:22px;">' +
                                        '<b>' +
                                        chartData.getTimeLabel(
                                            (this as any).x
                                        ) +
                                        '</b>' +
                                        getTooltipContent(
                                            (this as any).points,
                                            (this as any).point,
                                            chart,
                                            chartData
                                        ) +
                                        '</div>'
                                    );
                                },
                                categories: chartData.categories,
                                shadow: false,
                                valueDecimals: chartData.valueDecimals
                            },
                            plotOptions: {
                                series: {
                                    allowPointSelect: true
                                },
                                spline: {
                                    marker: {
                                        enabled: false
                                    }
                                },
                                line: {
                                    marker: {
                                        enabled: false
                                    }
                                }
                            },
                            series: configSeries
                        }}
                        callback={afterRender}
                    />
                </div>
            );

            charts.push(chart);

            return chartData;
        });

        return <div id="container">{charts}</div>;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveCharts.tsx